// Drizzle schema for the user-to-site assignments table.
//
// Split out of `./schema.ts` so the primary tables file stays under
// the 500-line policy cap (lint:max-lines). Re-exported from
// `@citycare/shared` via index.ts so the canonical import path is
// unchanged for consumers.
//
// `user_site_assignments` is the authoritative source for which
// field staff are allowed to capture against which sites. PowerSync
// sync rules use this table (joined to the JWT's `user_id` claim) to
// decide which site-scoped reference data and capture rows to push
// to a given client. See `docs/plans/powersync-implementation.md`
// HP2 for the design rationale and ADR-003 for why building-level
// concurrency stays an operational concern, not a system constraint.

import { index, uniqueIndex, uuid } from 'drizzle-orm/pg-core'
import { pgTable } from 'drizzle-orm/pg-core'

import { sites, users } from './schema'
import { createdAtColumn, updatedAtColumn } from './schema-shared'

export const userSiteAssignments = pgTable(
  'user_site_assignments',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    userId: uuid('user_id')
      .notNull()
      .references(() => users.id, { onDelete: 'cascade' }),
    siteId: uuid('site_id')
      .notNull()
      .references(() => sites.id, { onDelete: 'restrict' }),
    // createdBy = the admin who made the assignment. Null is allowed
    // only for seed data; runtime endpoints must always populate it.
    createdBy: uuid('created_by').references(() => users.id, {
      onDelete: 'set null',
    }),
    createdAt: createdAtColumn(),
    updatedAt: updatedAtColumn(),
  },
  (t) => ({
    uniqueUserSite: uniqueIndex('user_site_assignments_user_site_unique').on(
      t.userId,
      t.siteId,
    ),
    userIdx: index('user_site_assignments_user_id_idx').on(t.userId),
    siteIdx: index('user_site_assignments_site_id_idx').on(t.siteId),
  }),
)
